import { Injectable, inject } from '@angular/core';
import { IndividualConfig, ToastRef, ToastrService } from 'ngx-toastr';

export interface Feedback {
  title: string;
  message: string;
  options: Partial<IndividualConfig>;
}

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  readonly #errorOptions: Partial<IndividualConfig> = {
    disableTimeOut: true,
  };

  readonly toastr = inject(ToastrService);

  showError(message: string | undefined): ToastRef<unknown> {
    return this.toastr.error(message || 'An error occurred', '', this.#errorOptions).toastRef;
  }

  showErrorWithTitle({ title, message, options }: Partial<Feedback>): ToastRef<unknown> {
    return this.toastr.error(message || '', title || '', options || this.#errorOptions).toastRef;
  }

  showInfo(message: string): ToastRef<unknown> {
    return this.toastr.info(message).toastRef;
  }

  showInfoWithTitle({ title, message, options }: Partial<Feedback>): ToastRef<unknown> {
    return this.toastr.info(message || '', title || '', options).toastRef;
  }

  showSuccess(message: string): ToastRef<unknown> {
    return this.toastr.success(message).toastRef;
  }

  showSuccessWithTitle({ title, message, options }: Partial<Feedback>): ToastRef<unknown> {
    return this.toastr.success(message || '', title || '', options).toastRef;
  }

  showWarning(message: string): ToastRef<unknown> {
    return this.toastr.warning(message).toastRef;
  }

  showWarningWithTitle({ title, message, options }: Partial<Feedback>): ToastRef<unknown> {
    return this.toastr.warning(message || '', title || '', options).toastRef;
  }
}
